

































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import VLazyImage from 'v-lazy-image';

@Component({
  name: 'SupportOpened',
  components: {
    VLazyImage,
  },
  created() {
    this.fetchFeedback(this.$route.params.id);
  },
  destroyed() {
    this.clearSupportData();
  },
  props: {},
  data() {
    return {
      messageText: '',
      messageTextError: false,
      uploadedFiles: [],
      openedDeck: false,
      showImage: false,
      photo: {
        file: {},
      },
      sendInProgress: false,
      sentError: '',
    };
  },
  computed: {
    ...mapGetters('profile', ['actualFeedback', 'feedbackItemText']),
  },
  methods: {
    ...mapActions('profile', ['fetchFeedback', 'createNewMessage', 'clearSupportData']),

    formattedDate(str) {
      return this.$dayjs(str).format('DD.MM.YY, hh:mm');
    },

    load(event) {
      (this as any).$refs.image.loaded = true;
      (this as any).$refs.image.intersected = true;
    },

    show(photo) {
      (this as any).photo = photo;
      this.$nextTick(() => {
        (this as any).showImage = true;
      });
    },

    scrollToElement() {
      const lastElement = (this as any).$refs.messegesBlock;
      const chatBlock = document.querySelector('.supportOpened-component__chat-messages');
      if (lastElement && chatBlock) {
        this.$nextTick(() => {
          chatBlock.scrollTop = chatBlock.scrollHeight;
        });
      }
    },

    pickFile() {
      (this as any).sentError = '';
      (this as any).$refs.uploadFile.click();
    },

    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        const counts = files.length > 3 - this.uploadedFiles.length ? 3 - this.uploadedFiles.length : files.length;
        for (let i = 0; i < counts; i++) {
          const fr = new FileReader();
          const actualFile = files[i];
          fr.readAsDataURL(actualFile);
          fr.addEventListener('load', () => {
            this.uploadedFiles.push({filename: actualFile.name, content: fr.result});
            if (i === counts - 1) {
              e.target.value = '';
            }
          });
        }
      } else {
        console.error('error on upload photo');
      }
    },
    checkImg(stringBase64) {
      return stringBase64.split('base64', 1)[0].includes('image');
    },

    deleteUploadedFile(content) {
      for (const item in this.uploadedFiles) {
        if (this.uploadedFiles[item].content === content) {
          this.uploadedFiles.splice(parseInt(item, 10), 1);
          break;
        }
      }
    },

    sendMessage() {
      if ((this as any).sendInProgress) { return; }
      if (this.messageText) {
        const data = {
          text: this.messageText,
          files: this.uploadedFiles,
        };
        (this as any).sendInProgress = true;
        this.createNewMessage({id: this.$route.params.id, files: data})
            .then((response: any) => {
              if (response.status === 400 || response.status > 401) {
                const { mobile_errors } = response.data;
                (this as any).sentError = mobile_errors[0]?.messages[0];
                (this as any).sendInProgress = false;
                return;
              }
              this.messageText = '';
              this.uploadedFiles = [];
              if (this.$vuetify.breakpoint.xsOnly) {
                const page = document.querySelector('body');
                if (page) {
                  window.scrollTo(0, page.scrollHeight);
                }
              }
              (this as any).sendInProgress = false;
            })
            .catch((error: any) => {
              console.error(`message send error - ${error}`);
            });
      } else {
        this.messageTextError = true;
        setTimeout(() => { this.messageTextError = false; }, 3000);
      }
    },
  },
})
export default class SupportOpened extends Vue {}
